// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._195gv47k{margin-inline:var(--ds-space-250,20px)}._154ize3t{top:var(--ds-space-0,0)}\n._19pkze3t{margin-top:var(--ds-space-0,0)}\n._1bsb1osq{width:100%}\n._1ltvze3t{left:var(--ds-space-0,0)}\n._4t3i1osq{height:100%}\n._94n5u2gc{bottom:var(--ds-space-100,8px)}\n._kqswstnw{position:absolute}\n._otyr1jfw{margin-bottom:var(--ds-space-500,40px)}\n._uiztglyw{-webkit-user-select:none;-ms-user-select:none;user-select:none}", ""]);
// Exports
module.exports = exports;
